/* eslint-disable no-unused-vars */
import { cloneDeep } from 'lodash-es';
import {
  targetingPages,
  campaignPanels,
  campaignEnvironment,
  allSectionsArr,
  reattribution,
  fieldConvert,
} from 'constants';
import { isInvalidBid } from './bidValidation';
import { sortCreativeItems } from './creativesUtils';
import {
  Pause,
  PauseScheduler,
  Start,
  StartScheduler,
  ErrorMarker,
  StatusWarningYellowIcon,
  StatusWarningRedIcon,
  ArchiveStatus,
  DraftIcon,
  NavArrowDown,
  NavArrowRight,
} from 'assets/icons';
import { SelectedItem } from 'components';
import store from 'store';
import uuid from 'react-uuid';
// import { compareAsc } from 'date-fns';
import {
  // generalActions,
  // targetingActions,
  creativesActions,
  targetingPlacementsActions,
  formErrorsCampaign_action,
} from 'store/actions';

const [v1, v2] = [
  'appnext_event&clickid=xapnt1x&action=',
  'http://admin.appnext.com/PostInstall.aspx?clickid=xapnt1x&action=',
];

const install_callback = [
  'install_callback=appnext_install%26clickid%3Dxapnt1x',
  'rejected_install_callback=appnext_rejected%26clickid%3Dxapnt1x',
];

//import { Africa, Asia, Europe, NorthAmerica, Oceania, SouthAmerica } from './CONST_LOCATIONS';

export const createMapByNumber = (dataArray = [], numbersArray) => {
  const clonArr = cloneDeep(dataArray);
  const map = new Map();
  if (!dataArray.length) return map;
  clonArr?.forEach(({ pba_number, pba_name }) => {
    if (numbersArray.includes(pba_number)) {
      map.set(pba_number, {
        pba_name,
        pba_number,
      });
    }
  });
  return map;
};

export const targeting_title_icon_onBoadring = {
  locations_languages: {
    title: 'Go to Targeting by Devices & OS',
    icon: <NavArrowRight />,
  },
  devices_os: {
    title: 'Go to Bidding ',
    icon: <NavArrowDown />,
  },
};

export const targeting_title_icon_onGoing = {
  placements: {
    title: 'Go to Targeting by Locations & Languages',
    icon: <NavArrowRight />,
  },
  locations_languages: {
    title: 'Go to Targeting by Devices & OS',
    icon: <NavArrowRight />,
  },
  devices_os: {
    title: 'Go to Exclude Rules ',
    icon: <NavArrowRight />,
  },
  exclude_rules: {
    title: 'Go to Targeting by Custom Audience',
    icon: <NavArrowRight />,
  },
  custom_audience: {
    title: 'Go to Bidding',
    icon: <NavArrowDown />,
  },
};

export const checkCurrentTargetingSectionAndSetErrorField = (currentTab) => {
  const currentState = store.getState();
  const dispatch = store.dispatch;
  const { currentCampaignObj, selected_locations } = currentState.general.mainCampaignObject;

  const {
    target_type,
    target_apps_list,
    brands_audience_to_save,
    userAgentsOSType,
    userAgentsOSList,
    campaignLangs,
    location,
  } = currentCampaignObj;
  const { type } = currentState.targetingBrandsModels;
  const { inc } = brands_audience_to_save;
  const targeting_languages_tab = currentState.targetingLanguages.type;
  let devices_os_res = true;
  let locations_languages = true;

  switch (currentTab) {
    case targetingPages.placements:
      if (target_type === 2 && !target_apps_list) {
        dispatch(
          targetingPlacementsActions.updateErrorField({
            errorField: targetingPages.placements,
            newValue: true,
          }),
        );
        return false;
      }
      break;
    case targetingPages.locations_languages:
      if (targeting_languages_tab === 'specific_languages' && !campaignLangs) {
        dispatch(
          targetingPlacementsActions.updateErrorField({
            errorField: 'languages',
            newValue: true,
          }),
        );
        locations_languages = false;
      }
      if (+location === 2 && !selected_locations?.length) {
        dispatch(
          targetingPlacementsActions.updateErrorField({
            errorField: 'locations',
            newValue: true,
          }),
        );
        locations_languages = false;
      }
      return locations_languages;
    case targetingPages.devices_os:
      if (type === 'specific_brands_models' && !inc) {
        dispatch(
          targetingPlacementsActions.updateErrorField({
            errorField: 'devices',
            newValue: true,
          }),
        );
        devices_os_res = false;
      }
      if (userAgentsOSType === 2 && !userAgentsOSList?.length) {
        dispatch(
          targetingPlacementsActions.updateErrorField({
            errorField: 'os',
            newValue: true,
          }),
        );
        devices_os_res = false;
      }
      return devices_os_res;
    case targetingPages.custom_audience:
      break;
    default:
      console.log({ currentTab });
      return true;
  }
  return true;
};

export const targetingNavigation = (currentTab, setExpanded, setCurrentTab, environment) => {
  const currentState = store.getState();
  const { isOnBoarding } = currentState.general.mainCampaignObject.currentCampaignObj;
  switch (currentTab) {
    case targetingPages.placements:
      setCurrentTab(targetingPages.locations_languages);
      break;
    case targetingPages.locations_languages:
      setCurrentTab(targetingPages.devices_os);
      break;
    case targetingPages.devices_os:
      if (isOnBoarding) {
        setExpanded('bidding');
      } else {
        if (
          environment === campaignEnvironment.duplicate ||
          environment === campaignEnvironment.new_empty
        ) {
          setCurrentTab(targetingPages.custom_audience);
        } else setCurrentTab(targetingPages.exclude_rules);
      }
      break;
    case targetingPages.exclude_rules:
      if (isOnBoarding) {
        setExpanded('bidding');
      } else setCurrentTab(targetingPages.custom_audience);
      break;
    case targetingPages.custom_audience:
      setExpanded('bidding');
      break;
    default:
      console.log({ currentTab });
      break;
  }
};

export const transformInc = (inc) => {
  const pairs = inc.split(',').map((pair) => {
    const [key, value] = pair.split(':');
    return { key, value };
  });
  let result = {
    InitIncBrands: [],
    InitIncModels: [],
  };
  result = pairs.reduce((acc, pair) => {
    if (pair.key === 'Brand') {
      if (!acc.InitIncBrands) {
        acc.InitIncBrands = [];
      }
      acc.InitIncBrands.push(pair.value);
    } else if (pair.key === 'Model') {
      if (!acc.InitIncModels) {
        acc.InitIncModels = [];
      }
      acc.InitIncModels.push(+pair.value);
    }
    return acc;
  }, result);
  return result;
};

export const typeOfItem = (item, setIncludeSet, setExcludeSet, exclude, deleteAction) => {
  if (!item) return null;
  if (Object.prototype.hasOwnProperty.call(item, 'models'))
    return (
      <SelectedItem.ParentItem
        title='Brand'
        childrenName={item.brand}
        setIncludeSet={setIncludeSet}
        deleteAction={() => deleteAction(item.brand)}
        //deleteAction={() => setIncludeSet((newIncludeSet) => newIncludeSet.delete(item.brand))}
      />
    );

  if (Object.prototype.hasOwnProperty.call(item, 'model'))
    return (
      <SelectedItem.ChildrenItem
        title='Model'
        childrenName={item.model}
        counter={item.counter}
        parentName={item.brand}
        setExcludeSet={setExcludeSet}
        setIncludeSet={setIncludeSet}
        exclude={exclude}
      />
    );
};

export function sortLanguagesByLanguageName(languages) {
  languages.sort((a, b) => {
    const nameA = a.language_name.toUpperCase();
    const nameB = b.language_name.toUpperCase();
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  });
  return languages;
}

export const addUserAgentsOSNameListField = (campaignData) => {
  if (campaignData) {
    const version_list = campaignData?.userAgentOSs?.[1]?.map((item) => {
      return { value: item.user_agent_os_id, label: item.user_agent_os_name };
    });
    const selected_list = campaignData?.currentCampaignObj?.userAgentsOSList
      .split(',')
      .map((item) => +item);
    const selected_name_list = version_list
      ?.filter((version) => selected_list.includes(version.value))
      ?.map((item) => item.label)
      .join(',');
    const res = cloneDeep(campaignData);
    res.currentCampaignObj.userAgentsOSNameList = selected_name_list;
    //res.currentCampaignObj.location = 2;
    return res;
  }
};

//delete it?
// export const getCountryWithRegions = (country) => {
//   //console.log('getRegionsForCountry', country);
//   const continents = [...[Europe, Asia, NorthAmerica, Africa, SouthAmerica, Oceania]];
//   const continent = continents.find(
//     (continents) => continents.continent_code === country.continent_code,
//   );
//   const selectedCountry = cloneDeep(
//     continent?.countries.find((countryItem) => countryItem.country_name === country.country_name),
//   );
//   selectedCountry?.regions.forEach((region) => {
//     region.status = 'include';
//   });
//   //console.log('return selectedCountry', selectedCountry);
//   return cloneDeep(selectedCountry);
// };
//delete it?
// export const putToStoreAllCampaignData = (newCampaignData, dispatch, generalActions) => {
//   console.log('here')
//   newCampaignData && dispatch(generalActions.setCampaignDataForID(newCampaignData));
// };

//delete it?
// export const updateRecievedTargetingLocations = (selected_locations) => {
//   const dispatch = store.dispatch;

//   const cityList = selected_locations.filter((item) => item.type == 'city');
//   const countriesList = selected_locations.filter((item) => item.type == 'country');
//   let newLocationsLocal = [...cityList];
//   countriesList.forEach((country) => {
//     const countryFromLocalObj = getCountryWithRegions(country);
//     const regionList = selected_locations.filter((item) => item.type == 'region');

//     regionList.forEach((region) => {
//       countryFromLocalObj?.regions?.forEach((cregion) => {
//         if (cregion?.region === region?.region_name) {
//           cregion.status = region.status;
//         }
//       });
//     });

//     newLocationsLocal.push(countryFromLocalObj);
//     const oldRlist = selected_locations.filter((item) => item.type == 'region');
//     oldRlist.forEach((region) => {
//       newLocationsLocal.push(region);
//     });
//   });
//   const startingSet = new Set(newLocationsLocal);
//   console.log({ startingSet });
//   dispatch(targetingActions.setStartingTargetingLocations([...startingSet]));
//   dispatch(generalActions.saveNewLocationFilters([...startingSet]));
//   dispatch(generalActions.changeUnsavedData(false));
// };

export const checkCurrentCampaignObj1 = (
  openedPanel,
  setTrueErrorField,
  nextPanel,
  setExpanded,
  // environment,
) => {
  const currentState = store.getState();
  const { currentCampaignObj } = currentState.general.mainCampaignObject;
  const { app, isOnBoarding, bid, bidType } = currentCampaignObj;
  if (nextPanel === campaignPanels.creatives || nextPanel === campaignPanels.conversionTracking) {
    if (!app?.length) {
      setTrueErrorField(openedPanel);
      setExpanded(campaignPanels.main);
      return false;
    }
    if (isOnBoarding === '') {
      setTrueErrorField('campaign_type');
      setExpanded(campaignPanels.general);
      return false;
    }
    if (+bidType === 1 || !bid) {
      setExpanded(campaignPanels.bidding);
      return false;
    }
  }

  return true;
};

// const areAllCreativesHavingIcon = (creativesList) => {
//   for (let i = 0; i < creativesList.length; i++) {
//     if (!creativesList[i].icon && creativesList[i].status !== 9) {
//       return false;
//     }
//   }
//   return true;
// };
// const areAllCreativesHavingImage = (creativesList) => {
//   for (let i = 0; i < creativesList.length; i++) {
//     if (!creativesList[i].image && creativesList[i].status !== 9) {
//       return false;
//     }
//   }
//   return true;
// };

function isAdmin(state) {
  const authObj = state?.auth;
  if (Object.prototype.hasOwnProperty.call(authObj, 'pb_roles')) {
    const roles = authObj.pb_roles;
    return roles?.includes('admin');
  } else {
    return false;
  }
}

const checkCreativeItemFields = (
  creativeItem,
  fieldToCheck,
  creativeMessageFieldName,
  isTokenRequired,
) => {
  const fieldsRequiringLengthCheck = ['name', 'title', creativeMessageFieldName];

  for (const fieldName in creativeItem) {
    if (fieldToCheck.includes(fieldName)) {
      if (fieldName === 'creative_id_token') {
        if (isTokenRequired && !creativeItem[fieldName]) return false;
      } else {
        if (!creativeItem[fieldName] && creativeItem.status !== 9) {
          return false;
        }
        if (fieldsRequiringLengthCheck.includes(fieldName)) {
          if (creativeItem[fieldName].length < 2) {
            return false;
          }
        }
      }
    }
  }

  return true;
};

export const isCreativesSectionValid = (
  creativesList,
  creativeMessageFieldName,
  isAdmin,
  isRuCampaigns,
) => {
  if (!creativesList.length) return false;
  const isTokenRequired = !isAdmin && isRuCampaigns;
  const allCreativesIsFillCorrect = creativesList
    .filter(({ status }) => +status !== 9)
    .every((item) =>
      checkCreativeItemFields(
        item,
        ['name', 'title', 'creative_id_token', creativeMessageFieldName, 'icon', 'image'],
        creativeMessageFieldName,
        isTokenRequired,
      ),
    );

  return allCreativesIsFillCorrect;
};

function isCreativesTokensValid(creativesList, isRuCampaigns) {
  if (!isRuCampaigns || !creativesList) return true;

  const creativeTokens = creativesList.map(
    (item, ind) => item.creative_id_token || 'empty string' + ind,
  );
  const allTokensUnique = new Set(creativeTokens).size === creativeTokens.length;
  return allTokensUnique;
}

const checkTargetingSection = (
  location,
  selected_locations,
  target_type,
  target_apps_list,
  userAgentsOSList,
  userAgentsOSType,
  campaignLangs,
  targeting_languages_tab,
  type,
  inc,
) => {
  const isLocationErr = +location === 2 && !selected_locations?.length;
  const isPlacementErr = target_type === 2 && !target_apps_list;
  const isOSListErr = userAgentsOSType === 2 && !userAgentsOSList;
  const isLangErr = targeting_languages_tab === 'specific_languages' && !campaignLangs;
  const isBrandsErr = type === 'specific_brands_models' && !inc;

  const dispatch = store.dispatch;

  if (isPlacementErr) {
    dispatch(
      targetingPlacementsActions.updateErrorField({
        errorField: targetingPages.placements,
        newValue: true,
      }),
    );
  }
  if (isLangErr) {
    dispatch(
      targetingPlacementsActions.updateErrorField({
        errorField: 'languages',
        newValue: true,
      }),
    );
  }
  if (isBrandsErr) {
    dispatch(
      targetingPlacementsActions.updateErrorField({
        errorField: 'devices',
        newValue: true,
      }),
    );
  }
  if (isOSListErr) {
    dispatch(
      targetingPlacementsActions.updateErrorField({
        errorField: 'os',
        newValue: true,
      }),
    );
  }
  if (isLocationErr) {
    dispatch(
      targetingPlacementsActions.updateErrorField({
        errorField: 'locations',
        newValue: true,
      }),
    );
  }
  return isLocationErr || isPlacementErr || isOSListErr || isLangErr || isBrandsErr;
};

export const checkFormBeforeSave = (
  saveAsDraft,
  creativeMessageFieldName,
  minBid = 0,
  maxBid = window.bid_maximum,
) => {
  let allFieldsError = true;
  let isSaveAsDraft = false;
  let canBeSavedAsDraft = true;
  const currentState = store.getState();
  const { creativesList, selectedOnBoardIcon } = store.getState().creatives;
  const bidErrorFlag = currentState.formErrorsCampaign.bidding;
  const campaignNameError = currentState.formErrorsCampaign.campaign_name;
  const schedulerError = hasPastDuplicateSchedule(
    currentState.general.mainCampaignObject.currentCampaignObj,
    currentState.general.campaignEnvironment,
  );
  updateErrorField('general', schedulerError);
  const targeting_languages_tab = currentState.targetingLanguages.type;

  const {
    currentCampaignObj: {
      app,
      isOnBoarding,
      bid,
      location,
      target_type,
      target_apps_list,
      userAgentsOSList,
      userAgentsOSType,
      campaignLangs,
      brands_audience_to_save,
      isAllPlacements,
      bidType,
    },
    selected_locations,
    // allUserCampaigns,
  } = currentState.general.mainCampaignObject;

  const { type } = currentState.targetingBrandsModels;
  const { inc } = brands_audience_to_save;

  const isRuCampaigns =
    selected_locations.length === 0 ||
    selected_locations.some((item) => item.country_code === 'RU');
  const isTokenRequired = !isAdmin(currentState) && isRuCampaigns;
  const isCPM = bidType == 1;
  const isAllPlacementsAndCPM = isAllPlacements && isCPM;

  const errorChecks = [
    {
      condition: !app,
      errorField: 'main',
    },
    {
      condition: isOnBoarding === '',
      errorField: 'campaign_type',
    },
    {
      //condition: !isCampaignName(campaignName, allUserCampaigns),
      condition: campaignNameError,
      errorField: 'campaign_name',
    },
    {
      condition: schedulerError,
      errorField: 'general',
    },
    {
      condition: checkTargetingSection(
        location,
        selected_locations,
        target_type,
        target_apps_list,
        userAgentsOSList,
        userAgentsOSType,
        campaignLangs,
        targeting_languages_tab,
        type,
        inc,
      ),
      errorField: 'targeting',
    },
    {
      condition: isInvalidBid(bid, 0, minBid, maxBid) || bidErrorFlag || isAllPlacementsAndCPM,
      errorField: 'bidding',
    },
    {
      condition: !creativesList.length,
      errorField: 'creatives',
    },
    {
      condition: isOnBoarding === true && !selectedOnBoardIcon,
      errorField: 'creatives',
    },
    {
      condition:
        isOnBoarding === false &&
        !isCreativesSectionValid(
          creativesList,
          creativeMessageFieldName,
          isAdmin(currentState),
          isRuCampaigns,
        ),
      errorField: 'creatives',
    },
    {
      condition: isOnBoarding === false && !isCreativesTokensValid(creativesList, isRuCampaigns),
      errorField: 'creatives_tokens',
    },
    {
      condition: !isTrackingCorrect(isCPM),
      errorField: 'conversionTracking',
    },
  ];

  errorChecks.forEach(({ condition, errorField }) => {
    if (saveAsDraft && errorField === 'creatives' && condition && allFieldsError) {
      isSaveAsDraft = true;
    }
    if (condition) {
      const field = errorField === 'creatives_tokens' ? 'creatives' : errorField;
      if (errorField === 'creatives_tokens') isSaveAsDraft = false;
      updateErrorField(field, condition);
      allFieldsError = false;
    }
    if (errorField !== 'creatives' && errorField !== 'conversionTracking' && condition) {
      canBeSavedAsDraft = false;
    }
  });

  return { isFormCorrect: allFieldsError, isSaveAsDraft, canBeSavedAsDraft };
};

export const checkCreativeList = () => {
  const creativesList = store.getState().creatives.creativesList;
  const creativesListIsCorrect = creativesList.every((creativeItem) =>
    checkCreativeItemFields(creativeItem, ['image', 'icon']),
  );
  updateErrorField('creatives', !creativesListIsCorrect);
  return;
};

const isTrackingCorrect = (isCPM) => {
  const currentState = store.getState();
  const dispatch = store.dispatch;
  const { trackingError, isCustomTracking } = currentState.tracking;

  const creativeAndTrackingData = currentState?.creatives?.creativeAndTrackingData;
  const creativesTracking = creativeAndTrackingData?.creativesTracking;
  const fields = creativeAndTrackingData?.link_state_model_dic;

  if (!fields && !isCPM) return false;
  if (!fields && isCPM) return true;

  let result = true;

  let requiredFieldNames = [];
  const fieldNames = Object.keys(fields).map((field) => {
    const name = fieldConvert[field];
    if (fields[field].required) requiredFieldNames.push(name);
    return name;
  });

  if (isCustomTracking) {
    const creativesTracking = creativeAndTrackingData?.creativesTracking;
    if (!creativesTracking) result = false;

    creativesTracking.forEach((item) => {
      const isAllFieldsFilled = requiredFieldNames.every((field) => item[field]);
      if (!isAllFieldsFilled) {
        result = false;
        // show a creative with empty data
        const creativesList = currentState.creatives.creativesList;
        const newSelectedCreatives = creativesList.find(
          ({ bn_bannerid }) => bn_bannerid === item.bn_bannerid,
        );
        dispatch(creativesActions.changeCreative(newSelectedCreatives));
        updateErrorField('creativesConversionTracking', true);
      }
    });
  }

  fieldNames.forEach((name) => {
    if (trackingError[name]) {
      result = false;
    }
  });
  return result;
};

export const updateErrorField = (fieldName, value) => {
  const dispatch = store.dispatch;
  dispatch(formErrorsCampaign_action.updateErrorField({ errorField: fieldName, newValue: value }));
};

export const checkCurrentCampaignObj = (
  openedPanel,
  setTrueErrorField,
  nextPanel,
  setExpanded,
  environment,
) => {
  const allowedArr = getAllowedSelections(openedPanel);
  const currentState = store.getState();
  const { allUserCampaigns, original_cm_name } = currentState.general.mainCampaignObject;
  const { isCpmSelected } = currentState.general;
  const dispatch = store.dispatch;
  const minBidErrorFlag = currentState.formErrorsCampaign.bidding;
  const { currentCampaignObj, selected_locations } = currentState.general.mainCampaignObject;

  const { app, isOnBoarding, bid, campaignName, location, bidType, campaignBiddings } =
    currentCampaignObj;

  const isDuplicate = allUserCampaigns.some((cm) => {
    return cm === campaignName;
  });

  if (campaignPanels.main === openedPanel) {
    if (!app) {
      setTrueErrorField(openedPanel);
      return false;
    }
    if (isDuplicate && nextPanel !== campaignPanels.general) {
      setExpanded(campaignPanels.general);
      return false;
    }
    if (nextPanel === campaignPanels.general) {
      return true;
    }
    if (
      environment === campaignEnvironment.new_empty &&
      +location === 2 &&
      !selected_locations?.length &&
      nextPanel !== campaignPanels.targeting
    ) {
      setExpanded(campaignPanels.targeting);
      return false;
    }
  }
  if (
    campaignPanels.main === openedPanel &&
    nextPanel !== campaignPanels.general &&
    isOnBoarding === ''
  ) {
    setExpanded(campaignPanels.general);
    return false;
  }

  if (campaignPanels.general === openedPanel) {
    if (nextPanel === campaignPanels.main) {
      return true;
    }
    if (hasPastDuplicateSchedule(currentCampaignObj, environment)) {
      setTrueErrorField('general');
      return false;
    }
    const comp_type_not_selected = isOnBoarding === '';
    if (comp_type_not_selected) {
      setTrueErrorField('campaign_type');
      return false;
    } else if (!campaignName.length || campaignName.length > 100) {
      setTrueErrorField('campaign_name');
      return false;
    } else {
      if (environment === campaignEnvironment.duplicate) {
        const cmNameIsNotUnique = campaignName === original_cm_name;
        (cmNameIsNotUnique || isDuplicate) && setTrueErrorField('campaign_name');
        return !cmNameIsNotUnique && !isDuplicate;
      }
      if (environment === campaignEnvironment.edit) {
        isDuplicate && setTrueErrorField('campaign_name');
        return !isDuplicate;
      }

      if (environment === campaignEnvironment.new_empty) {
        if (isDuplicate) {
          setTrueErrorField('campaign_name');
          return false;
        }
        if (!isDuplicate && +location === 2 && !selected_locations?.length) {
          setExpanded(campaignPanels.targeting);
          return false;
        }
        if (!bid) {
          if (
            nextPanel === campaignPanels.creatives ||
            nextPanel === campaignPanels.conversionTracking
          ) {
            setExpanded(campaignPanels.bidding);
            return false;
          }
        }
        return true;
      }
    }
  }

  const { targetingSectionTabs } = currentState.targetingPlacements;

  if (campaignPanels.targeting === openedPanel) {
    if (allowedArr.includes(nextPanel)) {
      return true;
    }
    const errorFlag = checkCurrentTargetingSectionAndSetErrorField(targetingSectionTabs);

    if (+location === 2 && !selected_locations?.length && errorFlag) {
      dispatch(targetingPlacementsActions.changeTab('locations_languages'));
      return false;
    }

    if (!bid && errorFlag && nextPanel !== campaignPanels.bidding) {
      setExpanded(campaignPanels.bidding);
      return false;
    }
    return errorFlag;
  }
  if (campaignPanels.bidding === openedPanel) {
    if (allowedArr.includes(nextPanel)) {
      return true;
    }
    if (!bid) {
      setTrueErrorField(openedPanel);
      return false;
    }

    if (isCpmSelected && (!campaignBiddings || campaignBiddings?.length === 0)) {
      setTrueErrorField(openedPanel);
      return false;
    }

    return !minBidErrorFlag;
  }

  if (nextPanel === campaignPanels.creatives || nextPanel === campaignPanels.conversionTracking) {
    if (!app?.length) {
      setExpanded(campaignPanels.main);
      return false;
    }
    if (isOnBoarding === '') {
      setExpanded(campaignPanels.general);
      return false;
    }
    if (+bidType === 0 || !bid) {
      setExpanded(campaignPanels.bidding);
      return false;
    }
  }
  return true;
};

export const isCampaignName = (name, namesArr) => {
  let result = false;
  if (!name.length || name.length > 100) {
    result = true;
  }
  const isDuplicate = namesArr.some((cm) => {
    return cm === name;
  });
  if (isDuplicate) {
    result = true;
  }
  return result;
};

const getAllowedSelections = (openedSection) => {
  const index = allSectionsArr.indexOf(openedSection);
  const allowed = index !== -1 ? allSectionsArr.slice(0, index) : [...allSectionsArr];
  return allowed;
};
//for check tracking values 1 arg: array to check, 2 arg: array of fields to check
// export const isArrayHaveSameValues = (arr, validationFields) => {
//   if (!Array.isArray(arr)) {
//     return false;
//   }
//   const isSameField = (arr, field) => {
//     const firstValue = arr[0]?.[field];
//     return arr.every((item) => item[field] === firstValue);
//   };
//   return validationFields.every((field) => isSameField(arr, field));
// };

export const checkTrackingLinks = (trackingArr, activeCreativesList) => {
  // const link_state_model_dic = store.getState()?.creatives?.creativeAndTrackingData?.link_state_model_dic;

  // const fieldsNames = Object.keys(link_state_model_dic)?.map((name) => fieldConvert[name]);

  if (trackingArr?.length === 1) return true;

  const activeCreatives = activeCreativesList?.map((item) => item.bn_bannerid);
  const activeTrackingArr = trackingArr?.filter((item) =>
    activeCreatives?.includes(item.bn_bannerid),
  );

  // trackingArr = trackingArr?.filter((item) => activeCreatives.includes(item.bn_bannerid));

  const Deep_Link = [...new Set(activeTrackingArr?.map((item) => item.Deep_Link))];
  const Tracking_Link = [...new Set(activeTrackingArr?.map((item) => item.Tracking_Link))];
  const Impression_Link = [...new Set(activeTrackingArr?.map((item) => item.Impression_Link))];
  const VTA_Link = [...new Set(activeTrackingArr?.map((item) => item.VTA_Link))];

  // if (fieldsNames?.length === 2) {
  //   const [name1, name2] = fieldsNames;
  //   const linksArr1 = [...new Set(trackingArr?.map((item) => item[name1]))];
  //   const linksArr2 = [...new Set(trackingArr?.map((item) => item[name2]))];
  //   return linksArr1.length === 0 && linksArr2.length === 0;
  // }

  // console.log({ Deep_Link, Tracking_Link, Impression_Link, VTA_Link });
  // console.log(
  //   Deep_Link.length === 1 &&
  //     Tracking_Link.length === 1 &&
  //     Impression_Link.length === 1 &&
  //     VTA_Link.length === 1,
  // );
  return (
    Deep_Link.length === 1 &&
    Tracking_Link.length === 1 &&
    Impression_Link.length === 1 &&
    VTA_Link.length === 1
  );
};

export const add_tmp_id_to_all_data_put_to_store = (trackingData, creativeData, dispatch) => {
  // console.log('trackingData', trackingData);
  // console.log('creativeData', creativeData);
  const copy_creativeData = cloneDeep(sortCreativeItems(creativeData));
  const copy_trackingData = cloneDeep(trackingData);
  const defaultTitle = copy_trackingData?.app_name_full || copy_trackingData?.app_name || '';
  for (const creativeItem of copy_creativeData) {
    if (!creativeItem.title) {
      creativeItem.title = defaultTitle;
    }

    const current_bn_bannerid = creativeItem?.bn_bannerid;
    const id = uuid();
    //creativeItem.tmp_id = 'id'; //WHY ?
    const trackingVictim = copy_trackingData.creativesTracking.find(
      (item) => item?.bn_bannerid === current_bn_bannerid,
    );

    if (trackingVictim && !trackingVictim?.tmp_id) {
      trackingVictim.tmp_id = id;
    }
  }

  dispatch(
    creativesActions.add_tmp_id_to_creatives_and_tracking({
      trackingData: copy_trackingData,
      creativeData: copy_creativeData,
    }),
  );

  if (copy_creativeData?.[0]) {
    dispatch(creativesActions.changeCreative(copy_creativeData[0]));
  }
};

export const convertUrlToEventCallbacks = (url, adjustDomains) => {
  const { searchParams: params, hostname } = new URL(url);
  const isAdjust = adjustDomains.some((link) => link.includes(hostname) || hostname.includes(link));
  if (!isAdjust) return [];
  let eventCallbacks = [];
  params?.forEach((value, key) => {
    if (!key.includes('event_callback_')) {
      return;
    }
    eventCallbacks.push({
      event_callback_: key.replace('event_callback_', ''),
      template: `${value.includes(v1) ? v1 : v2}`,
      event_name: value
        .replace(v1, '')
        .replace(v2, '')
        .replace('&is_re_engagement={reattributed_at}', ''),
      end_of_line: '&is_re_engagement={reattributed_at}',
      token_id: uuid(),
    });
  });
  const numberOfCallbacks = eventCallbacks.length;
  if (numberOfCallbacks < 3) {
    for (let i = 0; i < 3 - numberOfCallbacks; i++) {
      eventCallbacks = [...eventCallbacks, createEventCallback()];
    }
  }
  //console.log(eventCallbacks);
  return eventCallbacks;
};

export const createEventCallback = () => ({
  event_callback_: '',
  template: `${v1}`,
  event_name: '',
  end_of_line: '&is_re_engagement={reattributed_at}',
  token_id: uuid(),
});

// export const uniqueEventCallbacksArr = (array1 = [], array2 = []) => {
//   return array1.concat(
//     array2.filter(
//       (item2) =>
//         !array1.some(
//           (item1) =>
//             item1.event_callback_ === item2.event_callback_ &&
//             item1.event_name === item2.event_name,
//         ),
//     ),
//   );
// };

export const getCleanUrl = (url, adjustDomains) => {
  if (!url || url?.startsWith('market://details')) {
    return '';
  }
  const cut_url = new URL(url);
  const isAdjust = adjustDomains.includes(cut_url.hostname);
  if (!isAdjust) return url;

  const paramsToDelete = [];
  cut_url.searchParams.forEach((value, key) => {
    if (
      key.includes('install_callback') ||
      key.includes('event_callback') ||
      key.includes('reattribution_callback')
    ) {
      paramsToDelete.push(key);
    }
  });
  for (const key of paramsToDelete) {
    cut_url.searchParams.delete(key);
  }
  install_callback.forEach((str) => {
    const [key, value] = str.split('=');
    cut_url.searchParams.set(key, value);
  });
  //console.log(decodedLink(cut_url.href).toString());
  //console.log(decodedLink(cut_url.href));
  return decodedLink(cut_url.href);
};

export const decodedLink = (link) => {
  try {
    // const url = new URL(link);
    const encodedURL = link;
    const [baseUrl, query] = encodedURL.split('?');
    const params = query?.split('&');
    const decodedParams = params
      ?.map((param) => {
        const [key, value] = param.split('=');
        const decodedValue =
          key.includes('install_callback') ||
          key.includes('reattribution_callback') ||
          key.includes('event_callback')
            ? value
            : decodeURIComponent(value);
        return value ? `${key}=${decodedValue}` : '';
      })
      .join('&');
    const fullyDecodedURL = decodedParams ? `${baseUrl}?${decodedParams}` : `${baseUrl}?`;
    return fullyDecodedURL;
  } catch (e) {
    console.log(e);
    return link;
  }
};

export const createFinalUrl = (url$, events$, isReattribution$, adjustDomains) => {
  if (!url$.value) {
    return '';
  }
  try {
    const url = new URL(url$.value);
    // const isAdjust = adjustDomains.includes(hostname);
    // if (!isAdjust) return url$.value;
    events$.value.forEach((item) => {
      if (item.event_callback_ && item.event_name) {
        url.searchParams.set(
          `event_callback_${item.event_callback_}`,
          `${item.template}${item.event_name}${item.end_of_line}`,
        );
      }
    });
    if (isReattribution$.value) {
      url.searchParams.set(reattribution[0], reattribution[1]);
    } else {
      url.searchParams.delete(reattribution[0], reattribution[1]);
    }
    const finalUrl = url.toString();
    return decodedLink(finalUrl);
  } catch (error) {
    //console.log('url is not valid');
  }
};

export const elementIsDisabled = (environment, pressed) => {
  if (environment !== campaignEnvironment.new_empty) {
    return pressed ? false : true;
  }
  return false;
};

export function compareDateObjects(obj1, obj2) {
  return obj1.from === obj2.from && obj1.to === obj2.to;
}

export const alphabeticallySort = (fieldName) => {
  return function (a, b) {
    if (!fieldName) {
      if (a < b) {
        return -1;
      }
      if (a > b) {
        return 1;
      }
      return 0;
    }
    if (a[fieldName] < b[fieldName]) {
      return -1;
    }
    if (a[fieldName] > b[fieldName]) {
      return 1;
    }
    return 0;
  };
};

export const createLocationsStrToSave = (include, exclude) => {
  const processItems = (items) =>
    items.map((item) => (typeof item === 'object' ? item.value : item));

  const includeItemsStr = Array.isArray(include) ? processItems(include).join(',') : '';
  const excludeItemsStr = Array.isArray(exclude) ? processItems(exclude).join(',') : '';

  const resultStr = `${includeItemsStr}|${excludeItemsStr}`;
  return resultStr;
};

export const goToLocationParent = (itemId, resType) => {
  let amountOfUnderscores = 0;
  for (const it of itemId) {
    if (it === '_') {
      amountOfUnderscores++;
    }
  }
  if (amountOfUnderscores !== 3) {
    throw new Error('amountOfUnderscores is not 3');
  }
  const [continent, country = '', region = '', city = ''] = itemId.split('_');
  if (resType === 'continent') {
    return `${continent}___`;
  }
  if (resType === 'country') {
    return `${continent}_${country}__`;
  }
  if (resType === 'region') {
    return `${continent}_${country}_${region}_`;
  }
};

// data is Time Zone agnostic (UTC format)!
export const isDateWasReached = (data) => {
  if (!data) return false;

  const currentDate = new Date();
  const incomingDate = new Date(data + ' UTC');

  return currentDate >= incomingDate;
  // return compareAsc(incomingDate, currentDate) === -1 ? true : false;
};

export const hasPastDuplicateSchedule = (campaign, environment) =>
  environment === campaignEnvironment.duplicate &&
  (isDateWasReached(campaign?.schedulerStartDate) || isDateWasReached(campaign?.schedulerEndDate));

export const choseCampaignStatusIcon = ({
  campaignStatus,
  // payment_status,
  _hasBanners,
  // _hasTracking,
  // bid_type,
  schedulerStartDate,
  schedulerEndDate,
  startWasReached,
  endWasReached,
  banner_list_no_tracking,
  statusDescr,
  status_name,
  call_to_action,
  status,
}) => {
  if (campaignStatus == 9) return ArchiveStatus;

  if (
    campaignStatus == 8
    // ||
    // !payment_status ||
    // !hasBanners ||
    // (+bid_type === 2 && !hasTracking)
  )
    return ErrorMarker;

  if (campaignStatus == 0) {
    if (status == 4) return StatusWarningRedIcon;
    if (call_to_action == 4) return StatusWarningYellowIcon;
    if (statusDescr?.includes('limit') && status_name === 'open') return Start;
    if (schedulerStartDate && !schedulerEndDate) return StartScheduler;
    if (schedulerEndDate && !schedulerStartDate) return StartScheduler;
    if ((schedulerEndDate && !endWasReached) || (schedulerStartDate && !startWasReached))
      return StartScheduler;
    return Start;
  }

  if (campaignStatus == 3) {
    // if (Boolean(schedulerStartDate) && !endWasReached) return PauseScheduler;
    if (_hasBanners === 0 || banner_list_no_tracking !== '') return DraftIcon;
    return Pause;
  }
};

export const replaceBnBannerId = ({ creativeListData, creativesAndTrackingData }) => {
  const bn_bannerIdMap = new Map();
  const newCreativeListData = creativeListData.map((creativeData) => {
    const id = uuid();
    bn_bannerIdMap.set(creativeData.bn_bannerid, id);
    const newItem = structuredClone(creativeData);
    newItem.bn_bannerid = id;
    newItem.tmp_id = id;
    newItem.bn_id = '';
    return newItem;
  });

  const newCreativesAndTrackingData = structuredClone(creativesAndTrackingData);
  newCreativesAndTrackingData.creativesTracking = creativesAndTrackingData.creativesTracking.map(
    (trackingData) => {
      const newItem = structuredClone(trackingData);
      newItem.bn_bannerid = bn_bannerIdMap.get(trackingData.bn_bannerid);
      newItem.tmp_id = bn_bannerIdMap.get(trackingData.bn_bannerid);
      newItem.bn_id = '';
      return newItem;
    },
  );

  return {
    newCreativeListData,
    newCreativesAndTrackingData,
  };
};

export const getMinTierValue = (includeObjArray, tireCountriesMap) => {
  if (!includeObjArray.length) {
    return 0;
  }
  return includeObjArray.reduce((minTier, { country_code }) => {
    return Math.min(minTier, tireCountriesMap.get(country_code) || 3);
  }, Infinity);
};
